import { render } from "./CIS-Content-Block-With-CTA.vue?vue&type=template&id=1aff954e&scoped=true"
import script from "./CIS-Content-Block-With-CTA.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Block-With-CTA.vue?vue&type=script&lang=js"

import "./CIS-Content-Block-With-CTA.vue?vue&type=style&index=0&id=1aff954e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aff954e"]])

export default __exports__